import { setInfluenceShowSteps as setInfluenceShowStepsDiagram , getInfluenceShowSteps as getInfluenceShowStepsDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type Props = ApiMethodBase & {
    show_steps?: boolean,
}

export const setInfluenceShowSteps = ({
    show_steps,
    eventEmitter,
}: Props) => {
   
    setInfluenceShowStepsDiagram(show_steps)
    apiProvider.updateDiagramInfluencers();
};

export const getInfluenceShowSteps = (): Props => getInfluenceShowStepsDiagram();